export const EventTypes = {
    COMMISSION: 'Commission',
    OBSERVATION: 'Observe',
}

export const NOT_AVAILABLE = "Not Available";
export const MAP_VIEW = "map";
export const TIMELINE_VIEW = "timeline";